jQuery(document).ready(function($) {

	$('.landing-speakers-item--link').on('click',function(e) {

		e.preventDefault();
		$( $(this).attr('href') ).addClass('is-open');

	});

  $('.landing-speakers-modal-close').on('click',function(e) {

		e.preventDefault();
		$( $(this).attr('href') ).removeClass('is-open');

	});

});
